import { i18n } from '@lingui/core';
import { DEFAULT_REDIRECT_URI } from '../constants';
export async function HandleChangeLang(lang) {
  const { messages } = await import(`../locales/${lang}.js`);
  i18n.load(lang, messages);
  i18n.activate(lang);
  localStorage.setItem('curLang', lang);
}
export function GetCurrentLanguage(){
  var curLang = localStorage.getItem('curLang');
  curLang = curLang == null ? 'vi-VN' : curLang;
  return curLang;
}

export const getRedirectUri = (url='') => {
  const lang = GetCurrentLanguage();
  const query = new URLSearchParams();
  if(url){
    query.set('url', url);
  }
  query.set('lang', lang)
  return `${DEFAULT_REDIRECT_URI}/redirect?${query}`;
}
